// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page header */
.my-horses-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.25rem;
}

.my-horses-title {
  margin: 0;
}

.my-horses-subtitle {
  font-size: 0.85rem;
  margin-bottom: 1.25rem;
}

/* Card grid — same pattern as people grid */
.horses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 0.75rem;
  align-items: start;
}

.horse-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--bs-border-color, #d0d7de);
  border-radius: 0.35rem;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
  overflow: hidden;
}

.horse-card--expanded {
  grid-column: 1 / -1;
  border-color: var(--sms-blue, #346498);
  box-shadow: 0 0 0 1px var(--sms-blue, #346498);
}

.horse-card__header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 0.75rem;
  border-bottom: 1px solid var(--bs-border-color, #d0d7de);
  background: var(--sms-gray-light, #f4f4f4);
}

.horse-card__name {
  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--sms-blue, #346498);
  letter-spacing: 0.02em;
  flex: 1;
  text-transform: uppercase;
}

.horse-card__pony-badge {
  font-size: 0.65rem;
  letter-spacing: 0.06em;
  flex-shrink: 0;
}

.horse-card__actions {
  display: flex;
  gap: 0.2rem;
  flex-shrink: 0;
}

.horse-card__action-btn {
  padding: 0.2rem 0.45rem;
  border: 1px solid var(--bs-border-color, #d0d7de);
  background: transparent;
  color: var(--sms-gray-mid, #888);
  border-radius: 0.25rem;
  line-height: 1;
  font-size: 0.8rem;
  transition: background 0.12s, color 0.12s, border-color 0.12s;
}

.horse-card__action-btn:hover,
.horse-card__action-btn.active {
  background: var(--sms-blue, #346498);
  border-color: var(--sms-blue, #346498);
  color: #fff;
}

.horse-card__action-btn--danger:hover {
  background: #dc3545;
  border-color: #dc3545;
  color: #fff;
}

.horse-card__body {
  flex: 1;
  padding: 0.6rem 0.75rem 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.horse-card__attr-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 0.75rem;
}

.horse-card__attr {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.horse-card__attr-label {
  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--sms-gray-mid, #888);
}

.horse-card__attr-value {
  font-size: 0.82rem;
  color: #2c2c2c;
}

.horse-card__ids {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.horse-card__id-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  font-size: 0.7rem;
  background: #eef3f8;
  border: 1px solid #ccd9e8;
  border-radius: 0.25rem;
  padding: 0.1rem 0.35rem;
  color: #2c2c2c;
}

.horse-card__id-org {
  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);
  font-weight: 700;
  color: var(--sms-blue, #346498);
  font-size: 0.65rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.horse-card__panel {
  padding: 0.75rem;
  border-top: 1px solid var(--bs-border-color, #d0d7de);
  background: #fafafa;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/horses/my-horses/my-horses.component.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iDAAiD;EACjD,sBAAsB;EACtB,gBAAgB;EAChB,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,wDAAwD;EACxD,0CAA0C;AAC5C;;AAEA;EACE,oEAAoE;EACpE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;EACjD,uBAAuB;EACvB,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;;EAEE,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oEAAoE;EACpE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oEAAoE;EACpE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,qDAAqD;EACrD,mBAAmB;AACrB","sourcesContent":["/* Page header */\n.my-horses-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.25rem;\n}\n\n.my-horses-title {\n  margin: 0;\n}\n\n.my-horses-subtitle {\n  font-size: 0.85rem;\n  margin-bottom: 1.25rem;\n}\n\n/* Card grid — same pattern as people grid */\n.horses-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 0.75rem;\n  align-items: start;\n}\n\n.horse-card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--bs-border-color, #d0d7de);\n  border-radius: 0.35rem;\n  background: #fff;\n  transition: border-color 0.15s, box-shadow 0.15s;\n  overflow: hidden;\n}\n\n.horse-card--expanded {\n  grid-column: 1 / -1;\n  border-color: var(--sms-blue, #346498);\n  box-shadow: 0 0 0 1px var(--sms-blue, #346498);\n}\n\n.horse-card__header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 0.75rem;\n  border-bottom: 1px solid var(--bs-border-color, #d0d7de);\n  background: var(--sms-gray-light, #f4f4f4);\n}\n\n.horse-card__name {\n  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--sms-blue, #346498);\n  letter-spacing: 0.02em;\n  flex: 1;\n  text-transform: uppercase;\n}\n\n.horse-card__pony-badge {\n  font-size: 0.65rem;\n  letter-spacing: 0.06em;\n  flex-shrink: 0;\n}\n\n.horse-card__actions {\n  display: flex;\n  gap: 0.2rem;\n  flex-shrink: 0;\n}\n\n.horse-card__action-btn {\n  padding: 0.2rem 0.45rem;\n  border: 1px solid var(--bs-border-color, #d0d7de);\n  background: transparent;\n  color: var(--sms-gray-mid, #888);\n  border-radius: 0.25rem;\n  line-height: 1;\n  font-size: 0.8rem;\n  transition: background 0.12s, color 0.12s, border-color 0.12s;\n}\n\n.horse-card__action-btn:hover,\n.horse-card__action-btn.active {\n  background: var(--sms-blue, #346498);\n  border-color: var(--sms-blue, #346498);\n  color: #fff;\n}\n\n.horse-card__action-btn--danger:hover {\n  background: #dc3545;\n  border-color: #dc3545;\n  color: #fff;\n}\n\n.horse-card__body {\n  flex: 1;\n  padding: 0.6rem 0.75rem 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.horse-card__attr-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem 0.75rem;\n}\n\n.horse-card__attr {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.horse-card__attr-label {\n  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--sms-gray-mid, #888);\n}\n\n.horse-card__attr-value {\n  font-size: 0.82rem;\n  color: #2c2c2c;\n}\n\n.horse-card__ids {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.horse-card__id-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  font-size: 0.7rem;\n  background: #eef3f8;\n  border: 1px solid #ccd9e8;\n  border-radius: 0.25rem;\n  padding: 0.1rem 0.35rem;\n  color: #2c2c2c;\n}\n\n.horse-card__id-org {\n  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);\n  font-weight: 700;\n  color: var(--sms-blue, #346498);\n  font-size: 0.65rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.horse-card__panel {\n  padding: 0.75rem;\n  border-top: 1px solid var(--bs-border-color, #d0d7de);\n  background: #fafafa;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
